import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function YesNoField({ label, required, properties }: FieldRendererProps) {
  const trueLabel = properties.trueLabel ?? "Yes";
  const falseLabel = properties.falseLabel ?? "No";

  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <div className="flex gap-2">
        <Button type="button" variant="outline" size="sm">
          {trueLabel}
        </Button>
        <Button type="button" variant="outline" size="sm">
          {falseLabel}
        </Button>
      </div>
    </div>
  );
}
